<script>
import EventBus from '../components/utils/EventBus'
import moment from 'moment'
export default {
  computed: {
    valid () {
      return this.error.length === 0
    }
  },
  props: {
    accordionId: String,
    validation: Array
  },
  data () {
    return {
      error: ''
    }
  },
  methods: {
    clearValidationError () {
      this.error = ''
      if (this.accordionId) {
        EventBus.$emit('setAccordionError', { accordionItemId: this.accordionId, isError: false })
      }
    },
    validate () {
      this.validation.forEach(rule => {
        if (typeof rule === 'string') {
          let re
          switch (rule) {
            case 'email':
              re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              if (!re.test(this.value)) {
                this.error = this.$t('validation.email')
              }
              break
            case 'hour':
              re = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/
              if (!re.test(this.value)) {
                this.error = this.$t('validation.hour')
              }
              break
            case 'is-date-after-today':
              if (this.value) {
                const dateTo = moment()
                const dateFrom = typeof this.value === 'string' ? moment(this.value, 'YYYY-MM-DD') : moment(this.value)
                if (!dateFrom.isSameOrAfter(dateTo, 'day')) {
                  this.error = this.$t('validation.dateAfterToday')
                }
              }
              break
            case 'positive-number':
              re = /^\+?(0|[1-9]\d*)$/
              if (this.value && this.value.length && !re.test(this.value)) {
                this.error = this.$t('validation.positiveNumber')
              }
              break
            case 'required':
              let valid = !!this.value

              if (Array.isArray(this.value)) {
                valid &= !!(this.value && this.value.length)
              } else {
                switch (typeof this.value) {
                  case 'string':
                    valid &= this.value && this.value.length > 0
                    break
                  case 'object':
                    valid &= !!(this.value && (this.value.getDate || Object.values(this.value).length)) || !!this.fromValue || !!this.toValue
                    break
                }
              }

              if (!valid) {
                this.error = this.$t('validation.required')
              }
              break
            case 'range': {
              if (parseInt(this.fromValue) > parseInt(this.toValue)) {
                this.error = this.$t('validation.rangeMismatch')
                break
              }
              const from = parseInt(this.fromValue)
              const to = parseInt(this.toValue)
              if (this.value.some(range => (range.from === from || to === this.toValue))) {
                this.error = this.$t('validation.duplicateRange')
              }
            }
              break
            case 'url': {
              re = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/
              if (this.value && this.value.length && !re.test(this.value)) {
                this.error = this.$t('validation.url')
              }
              break
            }
          }
        } else if (typeof rule === 'object') {
          let valid
          let otherValue
          switch (rule.name) {
            case 'conditional-required':
              const check = !!rule.param
              valid = !!this.value

              if (valid && rule.param) {
                switch (typeof this.value) {
                  case 'string':
                  case 'array':
                    valid &= !!(this.value.length)
                    break
                  case 'object':
                    valid &= !!(Object.values(this.value).length) || !!this.fromValue || !!this.toValue
                    break
                }
              }
              if (check && !valid) {
                this.error = this.$t(rule.message)
              }
              break
            case 'is-hour-before':
              valid = !!this.value

              if (valid && rule.param) {
                const hourTo = moment(rule.param, 'hh:mm')
                valid &= moment(this.value, 'hh:mm').isBefore(hourTo)
              }

              if (!valid) {
                this.error = this.$t('validation.hourBefore')
              }
              break
            case 'is-date-after':
              valid = !!this.value
              if (rule.param && rule.param.date) {
                otherValue = rule.param.date
              } else {
                otherValue = rule.param
              }

              if (valid && otherValue) {
                const dateFrom = typeof this.value === 'string' ? moment(this.value, 'YYYY-MM-DD') : moment(this.value)
                const dateTo = typeof otherValue === 'string' ? moment(otherValue, 'YYYY-MM-DD') : moment(otherValue)
                valid &= dateFrom.isAfter(dateTo, 'day') || dateFrom.isSame(dateTo, 'day')
              }

              if (this.value && !valid) {
                if (rule.param.message) {
                  this.error = this.$t(`validation.custom.${rule.param.message}`)
                } else {
                  this.error = this.$t('validation.dateAfter')
                }
              }
              break
            case 'is-date-before':
              valid = !!this.value
              if (rule.param && rule.param.date) {
                otherValue = rule.param.date
              } else {
                otherValue = rule.param
              }

              if (valid && otherValue) {
                const dateFrom = typeof this.value === 'string' ? moment(this.value, 'YYYY-MM-DD') : moment(this.value)
                const dateTo = typeof otherValue === 'string' ? moment(otherValue, 'YYYY-MM-DD') : moment(otherValue)
                valid &= dateFrom.isBefore(dateTo, 'day') || dateFrom.isSame(dateTo, 'day')
              }

              if (this.value && !valid) {
                if (rule.param.message) {
                  this.error = this.$t(`validation.custom.${rule.param.message}`)
                } else {
                  this.error = this.$t('validation.dateBefore')
                }
              }
              break
            case 'bigger-or-equal-than':
              valid = !!this.value
              otherValue = rule.param

              if (valid && otherValue) {
                valid &= parseFloat(this.value) >= parseFloat(otherValue)
              }

              if (this.value && this.value.length && !valid) {
                this.error = this.$t('validation.biggerOrEqualThan', { minValue: otherValue })
              }
              break
            case 'less-or-equal-than':
              valid = !!this.value
              otherValue = rule.param

              if (valid && otherValue) {
                valid &= parseFloat(this.value) <= parseFloat(otherValue)
              }

              if (this.value && this.value.length && !valid) {
                this.error = this.$t('validation.lessOrEqualThan', { maxValue: otherValue })
              }
              break

            case 'is-in-range':
              valid = !!this.value
              const range = rule.param

              if (valid && !!range) {
                valid &= (parseFloat(this.value[0].from) >= parseFloat(range.from) && parseFloat(this.value[0].to) <= parseFloat(range.to))
              }

              if (this.value && this.value.length && !valid) {
                this.error = this.$t('validation.isInRange')
              }
              break

            case 'max-length':
              valid = !!this.value
              otherValue = rule.param

              if (valid && otherValue) {
                valid &= parseFloat(otherValue) >= this.value.length
              }

              if (this.value && this.value.length && !valid) {
                this.error = this.$t('validation.maxLength', { maxValue: otherValue })
              }
              break

            case 'no-duplicate-content':
              valid = !!this.value
              otherValue = rule.param
              const index = rule.param.index

              if (valid && otherValue.contents.length) {
                const thisValue = [this.value, ...otherValue.contents.find((e, i) => i === index).tags.map(t => t.value)]
                const contents = otherValue.contents
                  .filter((e, i) => i < index)
                  .map(content => [content.description, ...content.tags.map(t => t.value)])
                  .filter(c => JSON.stringify(c) === JSON.stringify(thisValue))

                valid &= contents.length === 0
              }

              if (this.value && this.value.length && !valid) {
                this.error = this.$t('validation.custom.contentAlreadyPresent')
              }
          }
        }
      })

      if (!this.valid && this.accordionId) {
        EventBus.$emit('setAccordionError', { accordionItemId: this.accordionId, isError: true })
      }
      return this.valid
    }
  }
}
</script>
